import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Sidebar from "../shared/Sidebar";

function Scada() {
  
 const baseUrl = process.env.baseUrl;
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    scadaPresent: "",
    scadaFeatures: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.scadaPresent.trim()) {
      newErrors.scadaPresent = "SCADA/BMS Present field is required";
    }
    if (!formData.scadaFeatures.trim()) {
      newErrors.scadaFeatures = "SCADA Features field is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.post("/api/scada", formData); // Replace with your actual backend API
      navigate("/building");
    } catch (err) {
      console.error("Submission failed:", err);
      alert("Failed to submit SCADA data. Please try again.");
    }
  };

  return (
    <div className="container col-lg-9 mt-5">
      <div className="row">
        <div className="col-md-4">
          <Sidebar />
        </div>

        <div className="col-md-8">
          <div className="form-section">
            <h5 className="mb-4">SCADA / BMS Systems</h5>
            <form onSubmit={handleSubmit}>
              <div className="row mb-3">
                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="scadaPresent"
                    className={`form-control ${
                      errors.scadaPresent ? "is-invalid" : ""
                    }`}
                    placeholder="SCADA / BMS Present?"
                    value={formData.scadaPresent}
                    onChange={handleChange}
                  />
                  {errors.scadaPresent && (
                    <div className="invalid-feedback">
                      {errors.scadaPresent}
                    </div>
                  )}
                </div>

                <div className="col-md-12 mb-3">
                  <input
                    type="text"
                    name="scadaFeatures"
                    className={`form-control ${
                      errors.scadaFeatures ? "is-invalid" : ""
                    }`}
                    placeholder="SCADA Features"
                    value={formData.scadaFeatures}
                    onChange={handleChange}
                  />
                  {errors.scadaFeatures && (
                    <div className="invalid-feedback">
                      {errors.scadaFeatures}
                    </div>
                  )}
                </div>
              </div>

              <button type="submit" className="btn btn-custom w-100">
                Continue →
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Scada;
